<template>
  <v-container class="mt-10">
    <div class="display-1">Commandes</div>
    <v-divider class="my-10"></v-divider>
    <v-row>
      <v-col cols="12" sm="12">
        <router-link to="/commandes?status=pending">En attente</router-link>
        <router-link class="ml-2" to="/commandes?status=delivered,canceled"
          >Historique</router-link
        >
        <v-card outlined class="mt-2">
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="orders"
              :items-per-page="5"
              :server-items-length="total"
              class="elevation-0"
              :options.sync="options"
              :footer-props="{
                itemsPerPageText: 'Commandes par page',
              }"
            >
              <template v-slot:body="{ items }">
                <tbody class="text-left">
                  <tr
                    v-for="item in items.filter(
                      (i) =>
                        $route.query.status.split(',').indexOf(i.status) > -1
                    )"
                    :key="item._id"
                    @click="openDialog(item)"
                  >
                    <td>
                      {{ format(parseISO(item.createdAt), "dd.MM.yyyy") }}
                    </td>
                    <td>
                      {{ item.config.firstname }} {{ item.config.lastname }}
                    </td>
                    <td>{{ item.quantity }}</td>
                    <td>{{ orderStatusLabels[item.status] }}</td>
                  </tr>
                </tbody>
              </template>
              <!-- eslint-disable-next-line vue/valid-v-slot justification: possible according to vuetify documentation -->
              <template
                v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }"
                >{{ pageStart }}-{{ pageStop }} de {{ itemsLength }}</template
              >
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="600" @click:outside="closeDialog">
      <v-card>
        <v-card-title class="headline grey lighten-3">
          Mise à jour du statut de la commande
        </v-card-title>

        <v-card-text class="mt-5" v-if="editedItem">
          <v-container>
            <v-row>
              <v-col cols="12" sm="6">
                <div class="subtitle-2">DEMANDEUR</div>
                <div>
                  {{ editedItem.config.firstname }}
                  {{ editedItem.config.lastname }}
                </div>
                <div class="subtitle-2 mt-2">EMAIL</div>
                <div>
                  <a :href="`mailto:${editedItem.config.email}`">{{
                    editedItem.config.email
                  }}</a>
                </div>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="subtitle-2">SITE</div>
                <div>
                  {{ editedItem.config.address.location }}
                </div>
                <div class="subtitle-2 mt-2">ADRESSE</div>
                <div>
                  {{ editedItem.config.address.street
                  }}<span v-if="editedItem.config.address.po">, Case postale</span>
                </div>
                <div>
                  CH-{{ editedItem.config.address.city.split(",")[0]
                  }}{{ editedItem.config.address.city.split(",")[1] }}
                </div>
              </v-col>
            </v-row>
            <v-divider class="mt-5"></v-divider>
            <v-row>
              <v-col cols="12" sm="12"
                ><v-btn block outlined class="my-5" @click="downloadFile"
                  >Télécharger la planche</v-btn
                ></v-col
              >
            </v-row>
            <v-divider></v-divider>
            <v-row>
              <v-col cols="12" sm="12">
                <v-select
                  label="Statut"
                  outlined
                  dense
                  class="my-5"
                  :items="statuses"
                  v-model="editedItem.status"
                  color="blue-grey lighten-1"
                ></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="updateStatus">Mettre à jour</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
import { format, parseISO } from "date-fns";
import fileDownload from "js-file-download";

export default {
  props: ["orderStatusLabels", "openSnackbar", "updateNotifications"],
  data: () => ({
    options: {},
    orders: [],
    total: 0,
    headers: [
      {
        text: "Date",
        align: "start",
        sortable: false,
        value: "createdAt",
      },
      {
        text: "Demandeur",
        align: "start",
        sortable: false,
        value: "createdAt",
      },
      {
        text: "Quantité",
        align: "start",
        sortable: false,
        value: "quantity",
      },
      {
        text: "Statut",
        align: "start",
        sortable: false,
        value: "status",
      },
    ],
    editedItem: undefined,
    dialog: false,
    format,
    parseISO,
  }),
  computed: {
    statuses() {
      return Object.keys(this.orderStatusLabels).map((key) => ({
        text: this.orderStatusLabels[key],
        value: key,
      }));
    },
  },
  methods: {
    async getDataFromApi() {
      this.loading = true;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      const { data } = await axios({
        method: "get",
        url: `${process.env.VUE_APP_API_URI}/admin/orders?page=${page}&sortBy=${sortBy}&sortDesc=${sortDesc}&itemsPerPage=${itemsPerPage}&status=${this.$route.query.status}`,
      });
      this.loading = false;
      let { docs: orders, totalDocs } = data;
      const total = totalDocs;
      return {
        orders,
        total,
      };
    },
    async updateStatus() {
      try {
        const oldStatus = this.orders.find(
          (i) => i._id === this.editedItem._id
        ).status;
        const { data: updated } = await axios({
          method: "patch",
          url: `${process.env.VUE_APP_API_URI}/admin/orders/${this.editedItem._id}`,
          data: { status: this.editedItem.status },
        });
        this.orders.find((i) => i._id === updated._id).status = updated.status;
        this.closeDialog();
        this.openSnackbar({ color: "success", message: "Statut mis à jour" });
        if (oldStatus === "pending") {
          this.updateNotifications("orders", -1);
        }
        if (updated.status === "pending") {
          this.updateNotifications("orders", 1);
        }
      } catch (error) {
        this.openSnackbar({});
      }
    },
    async downloadFile() {
      try {
        const { data } = await axios({
          method: "get",
          url: `${process.env.VUE_APP_API_URI}/admin/orders/${this.editedItem._id}`,
          responseType: "arraybuffer",
        });
        fileDownload(
          data,
          `${this.editedItem.config.firstname}-${this.editedItem.config.lastname}-planche.pdf`
        );
      } catch (error) {
        this.openSnackbar({});
      }
    },
    openDialog(item) {
      this.editedItem = { ...item };
      this.dialog = true;
    },
    closeDialog() {
      this.editedItem = undefined;
      this.dialog = false;
    },
  },
  watch: {
    async $route() {
      this.options.page = null;
      this.options.page = 1;
    },
    options: {
      async handler() {
        const { orders, total } = await this.getDataFromApi();
        this.orders = orders;
        this.total = total;
      },
      deep: true,
    },
  },
};
</script>
